import { useCallback } from 'react';
import { H5 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import EnrollmentScheduleSelect from 'automation-ui-enrollment/components/scheduledEnrollment/EnrollmentScheduleSelect';
import ListSegmentationFilters from 'automation-ui-enrollment/components/common/ListSegmentationFilters';
import UISection from 'UIComponents/section/UISection';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import Small from 'UIComponents/elements/Small';
import { StyledCriteraBorder } from 'automation-ui-enrollment/components/eventEnrollment/steps/EventEnrollmentReview';
import DatasetSelect from 'automation-ui-enrollment/components/enrollment/manual/DatasetSelect';
import { getIsObjectlessFlow } from 'automation-ui-flow-core/flow/flowUtils';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ScheduledEnrollmentTriggersTab = ({
  flow,
  flowObjectTypeId,
  stagedFilters,
  setStagedFilters,
  stagedEnrollmentSchedule,
  setStagedEnrollmentSchedule,
  readOnly,
  isDataset,
  stagedEnrollmentCriteriaForDataset,
  setStagedEnrollmentCriteriaForDataset
}) => {
  const isObjectlessWorkflow = getIsObjectlessFlow(flow);
  const handleChange = useCallback(({
    target: {
      value: newSchedule
    }
  }) => setStagedEnrollmentSchedule(newSchedule), [setStagedEnrollmentSchedule]);
  const handleDatasetChange = useCallback(({
    target: {
      value: {
        datasetId,
        subviewId
      }
    }
  }) => {
    setStagedEnrollmentCriteriaForDataset === null || setStagedEnrollmentCriteriaForDataset === void 0 || setStagedEnrollmentCriteriaForDataset({
      datasetId,
      subviewId,
      triggerType: 'DATASET'
    });
  }, [setStagedEnrollmentCriteriaForDataset]);
  const getTitle = () => {
    if (isObjectlessWorkflow) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.subtitleObjectless"
      });
    } else if (isDataset) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.subtitleDataset"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.subtitle"
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(View, {
      marginBlockEnd: "400",
      as: "div",
      children: [/*#__PURE__*/_jsx(H5, {
        className: "m-top-2 display-inline m-right-1",
        children: getTitle()
      }), !isObjectlessWorkflow && /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.review.optional"
        })
      })]
    }), isDataset ? /*#__PURE__*/_jsx(DatasetSelect, {
      objectTypeId: flowObjectTypeId,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.datasetDropdownLabel"
      }),
      selectedDatasetId: stagedEnrollmentCriteriaForDataset === null || stagedEnrollmentCriteriaForDataset === void 0 ? void 0 : stagedEnrollmentCriteriaForDataset.datasetId,
      selectedSubviewId: stagedEnrollmentCriteriaForDataset === null || stagedEnrollmentCriteriaForDataset === void 0 ? void 0 : stagedEnrollmentCriteriaForDataset.subviewId,
      onDatasetSelect: handleDatasetChange,
      readOnly: !!readOnly
    }) : null, /*#__PURE__*/_jsx(EnrollmentScheduleSelect, {
      readOnly: readOnly,
      schedule: stagedEnrollmentSchedule,
      onChange: handleChange,
      isDataset: isDataset
    }), !isDataset && !isObjectlessWorkflow && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(UISection, {
        use: "island",
        className: "m-bottom-3",
        children: [/*#__PURE__*/_jsx(H5, {
          className: "m-top-2 display-inline-block m-bottom-0",
          children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
            baseLangKey: "automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.filtersSubtitle_cob",
            objectTypeId: flowObjectTypeId
          })
        }), /*#__PURE__*/_jsx(Small, {
          className: "display-block",
          children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
            baseLangKey: "automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.filtersDescription_cob",
            objectTypeId: flowObjectTypeId
          })
        })]
      }), /*#__PURE__*/_jsx(ListSegmentationFilters, {
        WrapperComponent: StyledCriteraBorder,
        value: stagedFilters,
        showDoneButton: true,
        readOnly: !!readOnly,
        objectTypeId: flowObjectTypeId,
        onChange: setStagedFilters
      })]
    })]
  });
};
export default ScheduledEnrollmentTriggersTab;